import { useId } from 'react';

/** Hand-drawn gradient underline placed under a word (parent must be `relative inline-block`). */
export const GradientSwash = ({ className = '' }) => {
  const id = useId().replace(/:/g, '');
  return (
    <svg
      className={`absolute left-0 w-full ${className}`}
      height="22"
      viewBox="0 0 400 22"
      preserveAspectRatio="none"
      aria-hidden="true"
    >
      <defs>
        <linearGradient id={`swash-${id}`} x1="0" x2="1">
          <stop offset="0" stopColor="#EC008C" />
          <stop offset="1" stopColor="#0CBFF2" />
        </linearGradient>
      </defs>
      <path d="M4 14 C 90 4, 210 2, 396 10" stroke={`url(#swash-${id})`} strokeWidth="5" fill="none" strokeLinecap="round" />
    </svg>
  );
};

export default GradientSwash;
